var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 0.25H3.25002C2.52067 0.25 1.8212 0.53973 1.30548 1.05546C0.78975 1.57118 0.50002 2.27065 0.50002 3V17C0.49901 17.1377 0.5359 17.2729 0.60665 17.391C0.67741 17.5091 0.77929 17.6054 0.90115 17.6695C1.02301 17.7335 1.16015 17.7627 1.29753 17.754C1.43491 17.7453 1.56724 17.6989 1.68002 17.62L7.00003 13.91L12.32 17.62C12.4467 17.7063 12.5967 17.7516 12.75 17.75C12.871 17.7486 12.9903 17.7213 13.1 17.67C13.2203 17.6041 13.3208 17.5072 13.3911 17.3894C13.4615 17.2716 13.499 17.1372 13.5 17V3C13.5 2.27065 13.2103 1.57118 12.6945 1.05546C12.1788 0.53973 11.4793 0.25 10.75 0.25Z",
    fill: "#00C853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkGreen);
export default __webpack_public_path__ + "static/media/BookmarkGreen.650b34013ce9fa8f13cb2025d752c3b7.svg";
export { ForwardRef as ReactComponent };